<template>
<div class="styled-radio-container styled-radio-container--ou-donation row">
 <div class="radio-part">
      <input id="amount_36" type="radio" class="amount" @click="selectedAmount = '36'" :checked="selectedAmount == 36">
      <FormLabel for="amount_36">
        <div class="label-amount">$36</div>
	    </FormLabel>
  </div>
   <div class="radio-part">
      <input id="amount_18" type="radio" class="amount" @click="selectedAmount = '18x6'" :checked="selectedAmount == '18x6'">
      <FormLabel for="amount_18">
        <div class="label-amount">$18 x 6</div>
	    </FormLabel>
  </div>
  <div class="radio-part">
    <input id="amount_36x6" type="radio" class="amount" @click="selectedAmount = '36x6'" :checked="selectedAmount == '36x6'">
    <FormLabel for="amount_36x6">
      <div class="label-amount">$36 x 6</div>
    </FormLabel>
  </div>
  <div class="radio-part">
    <input id="amount_72" type="radio" class="amount" @click="selectedAmount = '72x6'" :checked="selectedAmount == '72x6'">
    <FormLabel for="amount_72">
      <div class="label-amount">$72 x 6</div>
    </FormLabel>
  </div>
  <div class="radio-part">
    <input id="amount_180" type="radio" class="amount" @click="selectedAmount = '180x6'" :checked="selectedAmount == '180x6'">
    <FormLabel for="amount_180">
      <div class="label-amount">$180 x 6</div>
    </FormLabel>
  </div>
  <div class="radio-part">
    <input id="amount_360" type="radio" class="amount" @click="selectedAmount = '360x6'" :checked="selectedAmount == '360x6'">
    <FormLabel for="amount_360">
      <div class="label-amount">$360 x 6</div>
    </FormLabel>
  </div>  
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()

    watch(selectedAmount, () => {
      if (!selectedAmount.value)
        setValue('amount', selectedAmount.value)

      const [amount,period] = selectedAmount.value.split('x')

      setValue('amount', amount)

      if (!!period) {
        setValue('dayOfMonth', String(new Date().getDate()))
        setValue('periodMonths', period)
      } else {
        setValue('dayOfMonth', null)
        setValue('periodMonths', null)
      }
    })

    watch(
      () => form.value.currency,
      () => {
        setValue('amount', null)
      }
    )

    return {
      selectedAmount,
      currency: computed(() => form.value.currency),
    }
  },
})
</script>
<style scoped lang="scss">
.oudonate-other-amount .amount_other__wrapper {
  position: relative;
  margin-bottom: 10px;
  margin-right: 0;
  min-width: 16.6%;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding-left: 5px;
  flex: 1;
  line-height: 1;
  @media (max-width: 720px) {
    margin-right: 5px;
    margin-left: 5px;
    margin-bottom: 10px;
  }
  &:before {
    content: '$';
    position: absolute;
    padding: 15px 8px;
    border-right: 1px solid #ddd;
    height: 100%;
    background: #fff;
    top: 0px;
    left: 0;
  }
  input[type='number'] {
    border: none;
    margin-left: 20px;
    box-shadow: none;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type='number'] {
      background: #fff;
      margin-top: -15px;
    }
  }
}
</style>